import { useEffect, useState } from "react";
import "./AuthMatrix.scss";
import { ICON_BASE_PATH } from "@/app/utils/config";
import BankExpansionSkeleton from "@/app/components/webloading/skeletonloader/BankExpansionSkeleton";
import NoDataFound from "@/app/components/common/warning/NoDataFound";

interface DataProps {
  paymentTypeId: number;
  paymentTypeName: string;
  icon?: string;
}

interface TransactionTypesMenuProps {
  data: DataProps[];
  onSelect: (value: DataProps) => void;
  isLoadingTransactionTypes?: boolean;
  selectedPaymentTypeId?: number | null;
}

// . Static icon map for each transaction type ID
const ICON_MAP: Record<string, string> = {
  "121": "cash-icon.svg",
  "122": "earth-icon.svg",
  "182": "bank-icon.svg",
  "124": "earth-icon.svg",
  "128": "bill-icon.svg",
  "141": "credit-card-icon.svg",
  "150": "payer.svg",
  "181": "manage-bulk-file-payrolls.svg",
  "180": "bulk-fileuploadblack.svg",
  "152": "loan.svg",
  default: "default-transaction-icon.svg",
};

export const TransactionTypesMenu = ({
  data,
  onSelect,
  isLoadingTransactionTypes = false,
  selectedPaymentTypeId = null, // add this
}: TransactionTypesMenuProps) => {
  const [selectedType, setSelectedType] = useState<number | undefined>(
    undefined,
  );
 
  useEffect(() => {
    if (!isLoadingTransactionTypes && data?.length) {
      const preserved = selectedPaymentTypeId
        ? data.find((item) => item.paymentTypeId === selectedPaymentTypeId)
        : null;
      const itemToSelect = preserved ?? data[0];
 
      setSelectedType(itemToSelect.paymentTypeId);
      onSelect(itemToSelect);
    }
  }, [data, isLoadingTransactionTypes, selectedPaymentTypeId]);
 
  const handleSelect = (item: DataProps) => {
    setSelectedType(item.paymentTypeId);
    onSelect(item);
  };

  return (
    <div className="gx-transaction-card-grid ">
      {isLoadingTransactionTypes ? (
        // . Loading state
        Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="gx-transaction-card-menu">
            <BankExpansionSkeleton />
          </div>
        ))
      ) : data.length === 0 ? (
        // . Empty state
        // <div className="gx-no-data">No transaction types available</div>

        <NoDataFound
          message="No transaction types available for Selecetd bank"
          // submessage="There are currently no accounts eligible for the selected transaction type. Please choose a different option or contact support for assistance."
        />
      ) : (
        // . Data state
        data.map((item) => (
          <div
            key={item.paymentTypeId}
            onClick={() => handleSelect(item)}
            className={`gx-transaction-card-menu ${
              selectedType === item.paymentTypeId ? "selected" : ""
            }`}
          >
            <div className="gx-transaction-card-menu-info">
              <p className="gx-transaction-card-menu-label gx-p14-md">
                {item.paymentTypeName}
              </p>
            </div>
            <div className="gx-auth-right-arrow">
              <img
                src={`${ICON_BASE_PATH}right-arrow-icon.svg`}
                alt="right-icon"
              />
            </div>
          </div>
        ))
      )}
    </div>
  );
};
